<template>
  <div class="d-report">
    <div class="header">
      <div class="header-title">
        <span class="back" @click="fallback">
          <i class="iconfont">&#xe613;</i>
        </span>
        <span class="title">日报表</span>
      </div>
      <div>
        <div class="header-select">
          <awesome-picker
            ref="selectTypePicker"
            :textTitle="typePicker.textTitle"
            :anchor="typePicker.anchor"
            :data="typePicker.data"
            @confirm="handleSelectType"
          ></awesome-picker>
          <div class="select-wrapper" @click="TypeSelectShow">
            <span class="select">{{currentType.value}}</span>
            <span class="icon-wrapper">
              <i class="iconfont select-icon">&#xe61c;</i>
            </span>
          </div>
        </div>
        <div class="header-select">
          <awesome-picker
            ref="selectDatePicker"
            :data="datePicker.data"
            :textTitle="datePicker.textTitle"
            :anchor="datePicker.anchor"
            @confirm="handleSelectDate"
          ></awesome-picker>
          <div class="select-wrapper" @click="dateSelectShow">
            <span class="select select-date">{{currentDate}}</span>
            <span class="icon-wrapper">
              <i class="iconfont select-icon">&#xe61c;</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="report-list-wrapper" ref="DReportScorll">
      <ul class="report-list">
        <li class="report-item" v-for="(item,index) in dayReportList" :key="index">
          <p class="item-title">{{item.time}}</p>
          <router-link
            :to="{name: 'Register', params: {selectDate: item.time,type: 'update'}}"
            tag="div"
            class="item-content"
            v-show="show(item)"
          >
            <div class="wrapper">
              <p class="number">{{item.in_count}}</p>
              <p class="text">到诊</p>
            </div>
            <div class="wrapper">
              <p class="number">{{item.dialog_count}}</p>
              <p class="text">对话</p>
            </div>
            <div class="wrapper">
              <p class="number">{{item.sure_count}}</p>
              <p class="text">确诊对话</p>
            </div>
            <div class="wrapper">
              <p class="number">{{item.cost_price}}</p>
              <p class="text">消费</p>
            </div>
          </router-link>
          <div :to="{name: 'Register', params: {selectDate: item.time}}" tag="div" class="item-link" v-show="!show(item)">暂无数据</div>
        </li>
      </ul>
      <!-- <div class="tips" v-if="isShow">暂无数据</div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import BScroll from "better-scroll";
import { fallback, getDay, getDates, defPickerDate } from "@/assets/js/_mm.js";
export default {
  name: "PlanHome",
  props: {
    date: String
  },
  data() {
    return {
      typePicker: {
        data: [
          { sign: 1, value: "全部" },
          { sign: 2, value: "竞价" },
          { sign: 3, value: "优化" },
          { sign: 4, value: "门户" },
          { sign: 6, value: "新媒体" },
          { sign: 7, value: "资源合作" },
          { sign: 8, value: "无轨迹" },
          { sign: 5, value: "其他" }
        ],
        textTitle: "类型选择",
        anchor: []
      },
      datePicker: {
        data: this.defPickerDate(),
        textTitle: "月份选择",
        anchor: this.defAnchor()
      },
      currentDate: (() => {
        return (
          this.date ||
          new Date().getFullYear() + "年" + (new Date().getMonth() + 1) + "月"
        );
      })(),
      currentFullYear: (() => {
        return new Date().getFullYear();
      })(),
      currentType: { sign: 1, value: "全部" },
      dayReportList: [],
      isShow: false
    };
  },

  methods: {
    fallback,
    defPickerDate,
    defAnchor() {
      let year = this.date.match(/\d+/g)[0];
      let month = this.date.match(/\d+/g)[1];
      return [{ value: year + "年" }, { value: month + "月" }];
    },
    TypeSelectShow() {
      this.$refs.selectTypePicker.show();
    },
    show(item) {
      return Object.keys(item).length != 1 ? true : false;
    },
    handleSelectType(e) {
      let type = this.typePicker["data"][e[0]["index"]]["sign"];
      let date = this.currentDate.replace(/(\d+)[\D]+(\d+)[\D]+/, "$1-$2");
      this.currentType = {
        sign: type,
        value: e[0]["value"]
      };
      this.typePicker.anchor = e;
      this.getDayRepopt(type, date);
    },
    dateSelectShow() {
      this.$refs.selectDatePicker.show();
    },
    handleSelectDate(e) {
      let year = e[0]["value"].replace(/[^\d]+/g, "");
      let month = e[1]["value"].replace(/[^\d]+/g, "");
      let date = year + "-" + month;
      this.currentDate = e[0]["value"] + e[1]["value"];
      this.datePicker.anchor = e;
      this.getDayRepopt(this.currentType.sign, date);
    },
    _initDReportScorll() {
      this.$nextTick(() => {
        this.DReportScorll = new BScroll(this.$refs.DReportScorll, {
          click: true,
          swipeBounceTime: 100
        });
      });
    },
    getDayRepopt(type, date) {
      let year = this.currentDate.split(/[\D]+/g)[0];
      let month = this.currentDate.split(/[\D]+/g)[1];
      let nowYear = new Date().getFullYear();
      let nowMonth = new Date().getMonth() + 1;
      axios
        .get("/phal/public/", {
          params: {
            s: "App.Report.Sel_day_report",
            hos_id:
              this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
            sign: type || 1,
            time: date || this.date.replace(/(\d+)[\D]+(\d+)[\D]+/, "$1-$2")
          }
        })
        .then(res => {
					console.log(res)
          let result = res.data;
          if (result.ret && result.ret === 200) {
            let data = result.data;
            let newArrar = [];
            if ((month == nowMonth && year == nowYear) || data.length != 0) {
              let d = new Date().getDate();
              // if (d === 1) {
              //   this.isShow = true;
              // } else {
              //   d -= 1;
              //   this.isShow = false;
              // }

              if (month != nowMonth || (year != nowYear && month == nowMonth)) {
                d = getDates(month, year);
              }
              for (let i = 1; i <= d; i++) {
                let temp = {};
                for (let key in data) {
                  if (data[key]["time"].split("-")[2] == i) {
                    let cost_price =
                      data[key]["cost_price"] ||
                      data[key]["jj_cost_price"] ||
                      data[key]["yh_cost_price"] ||
                      data[key]["mh_cost_price"] ||
                      data[key]["xmt_cost_price"] ||
                      data[key]["zyhz_cost_price"] ||
                      data[key]["wgj_cost_price"] ||
                      data[key]["qt_cost_price"];

                    let dialog_count =
                      data[key]["dialog_count"] ||
                      data[key]["jj_dialog_count"] ||
                      data[key]["yh_dialog_count"] ||
                      data[key]["mh_dialog_count"] ||
                      data[key]["xmt_dialog_count"] ||
                      data[key]["zyhz_dialog_count"] ||
                      data[key]["wgj_dialog_count"] ||
                      data[key]["qt_dialog_count"];

                    let in_count =
                      data[key]["in_count"] ||
                      data[key]["jj_in_count"] ||
                      data[key]["yh_in_count"] ||
                      data[key]["mh_in_count"] ||
                      data[key]["xmt_in_count"] ||
                      data[key]["zyhz_in_count"] ||
                      data[key]["wgj_in_count"] ||
                      data[key]["qt_in_count"];

                    let sure_count =
                      data[key]["sure_count"] ||
                      data[key]["jj_sure_count"] ||
                      data[key]["yh_sure_count"] ||
                      data[key]["mh_sure_count"] ||
                      data[key]["xmt_sure_count"] ||
                      data[key]["zyhz_sure_count"] ||
                      data[key]["wgj_sure_count"] ||
                      data[key]["qt_sure_count"];
                    temp = {
                      time: data[key]["time"],
                      cost_price: cost_price ? Math.round(cost_price) : 0,
                      dialog_count: dialog_count ? dialog_count : 0,
                      in_count: in_count ? in_count : 0,
                      sure_count: sure_count ? sure_count : 0
                    };
                    break;
                  }
                }
                if (Object.keys(temp).length == 0) {
                  newArrar.push({
                    time: year + "-" + month + "-" + i
                  });
                } else {
                  newArrar.push(temp);
                }
              }
            } else {
              this.isShow = true;
            }
            this.dayReportList = newArrar.reverse();
          }
        });
    }
  },
  mounted() {
    this._initDReportScorll();
    this.getDayRepopt();
  }
};
</script>

<style lang="stylus" scoped>
.d-report {
  width: 100%;
  height: 100%;
  background-color: #f2f2f2;

  .header {
    display: flex;
    justify-content: space-between;
    height: 1.1rem;
    padding: 0 0.2rem 0 0.4rem;
    background-color: #fff;

    .header-title {
      line-height: 1.1rem;
      color: #1d1d1d;
      font-size: 0;

      .back {
        display: inline-block;
        width: 0.64rem;
        font-size: 0.42rem;

        .iconfont {
          vertical-align: middle;
          font-size: 0.42rem;
        }
      }

      .title {
        font-size: 0.3rem;
      }
    }

    .header-select {
      display: inline-block;
      vertical-align: middle;

      .select-wrapper {
        display: inline-block;
        font-size: 0;

        .select {
          box-sizing: border-box;
          display: inline-block;
          vertical-align: top;
          width: 1.48rem;
          height: 0.58rem;
          line-height: 0.58rem;
          font-size: 0.28rem;
          text-align: center;
          border: 1px solid #666666;
          border-right: none;
        }

        .select-date {
          width: 2rem;
        }

        .icon-wrapper {
          box-sizing: border-box;
          display: inline-block;
          vertical-align: top;
          width: 0.48rem;
          height: 0.58rem;
          line-height: 0.58rem;
          text-align: center;
          border: 1px solid #666666;

          .select-icon {
            font-size: 0.28rem;
          }
        }
      }
    }
  }

  .report-list-wrapper {
    position: fixed;
    top: 1.1rem;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;

    .report-list {
      .report-item {
        padding: 0.3rem 0.2rem 0.4rem 0.2rem;
        background-color: #ffffff;

        &+.report-item {
          margin-top: 0.2rem;
        }

        .item-title {
          color: #999999;
        }

        .item-content {
          display: flex;

          .wrapper {
            flex: 1;
            text-align: center;

            .number {
              margin: 0.36rem 0;
              color: #0066ff;
              font-size: 0.36rem;
            }

            .text {
              color: #666666;
            }
          }
        }

        .item-link {
          width: 100%;
          height: 0.9rem;
          margin-top: 15px;
          line-height: 0.9rem;
          color: #ccc;
          font-size: 0.28rem;
          text-align: center;
        }
      }
    }

    .tips {
      margin-top: 100px;
      font-size: 32px;
      color: #666666;
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/d-report/d-report.vue